import * as React from 'react';
import { type ActionWithRulesProps } from 'react-querybuilder';
import { IconButton } from '../../../buttons';

export const RemoveGroupAction = (props: ActionWithRulesProps) => {
  const { handleOnClick, title, disabled } = props;

  return (
    <IconButton
      size="small"
      name="close"
      onClick={handleOnClick}
      title={title}
      disabled={disabled}
    />
  );
};
